import React, {
  useState,
  useCallback,
  useEffect,
  useMemo
} from 'react';
import DataGrid, { Column, Sorting } from 'devextreme-react/data-grid';
import { Button, SelectBox, Template, Validator } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import DateBox from 'devextreme-react/date-box';
import { NumberBox } from 'devextreme-react/number-box';
import TextBox from 'devextreme-react/text-box';
import { RequiredRule } from 'devextreme-react/gantt';
import PopupMVP from '../PopupMVP';
import DateRangePicker from '../DateRangePicker';
import style from './reports.module.scss';
import DataGridMVP from '../DataGridMVP';
import columnDataGridReports from './columnDataGridHolderReports';
import { compare } from '../../utils/functions';

const Reports = ({
  error,
  getReportCreate,
  getReportErrorClose,
  getReportProductTypes,
  getReportTypes,
  getReportUsers,
  getHolderReportsByStock,
  getDocumentsNextNumber,
  delDocumentsNextNumber,
  deleteHolderReport,
  popupActReducer: {
    okRequest: popupOkRequest
  },
  isOffBalanceSheet,
  modalErrorOpen,
  okRequest,
  plantId,
  typeStock,
  reportReducer: {
    loading,
    reportProductTypes,
    reportTypes,
    reportUsers
  },
  userReducer: {
    id
  },
  documentsReducer: {
    holderReportsByStock,
    number,
    reportDelete
  },
  tabsReducer: { tabSelect }
}) => {
  const [visiblePopup, setVisiblePopup] = useState(false);
  // модалка таблицы отчета хранителей
  const [visibleHolderReportPopup, setVisibleHolderReportPopup] = useState(false);
  // модалка удаления отчета хранителя
  const [visibleHolderReportDeletePopup, setVisibleHolderReportDeletePopup] = useState(false);
  // выбранные элементы таблицы отчета хранителей
  const [dataSource, setDataSource] = useState({ selectList: [] });
  const [popupData, setPopupData] = useState({});
  const [tStartDate, setTStartDate] = useState('');
  const [tEndDate, setTEndDate] = useState('');
  const [tStartDateTime, setTStartDateTime] = useState('');
  const [errVal, setErrVal] = useState(false);
  const [isExcel, setIsExcel] = useState(false);
  const [isHolderReportFormValid, setHolderReportFormValid] = useState({
    docId: false,
    reportDate: false
  });
  // флаг определяющий был ли сформирован отчет хранителя для логики удаления номеров документов
  const [reportCreated, setReportCreated] = useState(false);
  const [data] = useState([
    {
      id: 0,
      name: formatMessage('textReport')[0],
      url: '/report',
      type: 'HOLDER_REFERENCE_REPORT'
    },
    {
      id: 1,
      name: formatMessage('textReport')[1],
      url: '/report',
      type: 'HOLDER_REPORT',
      selectCalculationPay: 0
    },
    {
      id: 2,
      name: formatMessage('textReport')[2],
      url: '/report',
      type: 'DOC_SIGN_REGISTRY',
      selectTypeAct: 0
    },
    {
      id: 3,
      name: formatMessage('textReport')[3],
      url: '/report',
      type: 'SHIPPING_PLAN'
    },
    {
      id: 4,
      name: formatMessage('textReport')[4],
      url: '/report',
      type: 'INVENTORY'
    },
    {
      id: 5,
      name: formatMessage('textReport')[5],
      url: '/report',
      type: 'MOVEMENT'
    },
    {
      id: 6,
      name: formatMessage('textReport')[6],
      url: '/report',
      type: 'INV_3'
    },
    {
      id: 7,
      name: formatMessage('textReport')[7],
      url: '/report',
      type: 'OVER_STORAGE_REPORT'
    },
    {
      id: 8,
      name: formatMessage('textReport')[8],
      url: '/report',
      type: 'FINISHED_PRODUCT_REPORT'
    },
    {
      id: 9,
      name: formatMessage('textReport')[9],
      url: '/report',
      type: 'TASK_REPORT'
    },
    {
      id: 10,
      name: formatMessage('textReport')[10],
      url: '/report',
      type: 'RETURN_REPORT'
    },
    {
      id: 11,
      name: formatMessage('textReport')[11],
      url: '/report',
      type: 'TTN_REPORT'
    },
    {
      id: 12,
      name: formatMessage('textReport')[12],
      url: '/report',
      type: 'PIECES_ON_HOLD_REPORT'
    },
    {
      id: 13,
      name: formatMessage('textReport')[14],
      url: '/reports/documents/multiple',
      type: 'DOC_SIGN_PRINTED_REGISTRY',
      selectTypeAct: 0
    }
  ]);
  const [calculationPay] = useState(
    [
      {
        id: 0,
        name: formatMessage('textReportCalculationPay').data[0]
      },
      {
        id: 1,
        name: formatMessage('textReportCalculationPay').data[1]
      }
    ]
  );
  const [typeAct] = useState(
    [
      {
        id: 0,
        name: formatMessage('textReportTypeAct').data[0]
      },
      {
        id: 1,
        name: formatMessage('textReportTypeAct').data[1]
      },
      {
        id: 2,
        name: formatMessage('textReportTypeAct').data[2]
      }
    ]
  );
  const [acts] = useState(
    [
      {
        value: 1,
        key: formatMessage('textData').acceptanceTransfer1Number
      },
      {
        value: 3,
        key: formatMessage('textData').inventoryItems3Number
      },
      {
        value: 15,
        key: formatMessage('textData').acceptanceTransfer15Number
      }
    ]
  );
  const [selectedData, setSelectedData] = useState({
    selectedProductType: null,
    selectedUser: null,
    selectedAct: null
  });
  const [dross, setDross] = useState(null);

  const calendarYearPreset = (isEnd) => {
    const currentDate = new Date();
    let startDate;
    let endDate;

    if (currentDate.getMonth() === 0) {
      startDate = new Date(Date.UTC(currentDate.getFullYear() - 1, 0, 1));
      endDate = new Date(Date.UTC(currentDate.getFullYear(), 0, 31, 0));
    } else {
      startDate = new Date(Date.UTC(currentDate.getFullYear(), 0, 1));
      endDate = new Date(Date.UTC(currentDate.getFullYear(), 11, 31));
    }

    if (isEnd) return endDate;
    return startDate;
  };

  /** Фильтры по таблице */
  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: calendarYearPreset(),
    dateTo: calendarYearPreset(true),
    filter: ''
  });

  useEffect(() => {
    if (number) {
      setPopupData((item) => ({
        ...item,
        docId: number
      }));
    }
  }, [number]);

  // получение списка отчетов хранителя
  const getReportList = useCallback(() => {
    if (visiblePopup) {
      getHolderReportsByStock({
        plantId,
        ...filterDataGrid
      });
    }
  }, [getHolderReportsByStock, plantId, filterDataGrid, visiblePopup]);

  // обновление списка отчетов хранителя после успешного формирования файла
  useEffect(() => {
    if (popupData.type === 'HOLDER_REPORT') {
      if (popupOkRequest) {
        setTimeout(() => {
          getReportList();
        }, 2500);
      } else {
        getReportList();
      }
    }
  }, [popupData.type, getReportList, popupOkRequest]);

  useEffect(() => {
    if (reportDelete.okRequest) {
      setVisibleHolderReportDeletePopup(false);
    }
  }, [reportDelete]);

  // получение нового номера отчета
  useEffect(() => {
    if (visibleHolderReportPopup && plantId) {
      getDocumentsNextNumber({ plant: plantId });
    }
  }, [
    getDocumentsNextNumber,
    plantId,
    visibleHolderReportPopup
  ]);

  const [reportData, setReportData] = useState({
    docNumId: '',
    docId: '',
    docDate: '',
    docTypeNumId: null,
    docStatus: null
  });

  // удаление отчета
  const handleDeleteReport = useCallback(() => {
    deleteHolderReport({ docNumId: reportData.docNumId, plantId, ...filterDataGrid });
  }, [deleteHolderReport, reportData.docNumId, plantId, filterDataGrid]);

  const onSelectionChanged = useCallback(({ selectedRowsData }) => {
    if (selectedRowsData.length) {
      setReportData({
        docNumId: selectedRowsData[0].docNumId,
        docId: selectedRowsData[0].docId,
        docDate: selectedRowsData[0].docDate,
        docTypeNumId: selectedRowsData[0].docTypeNumId,
        docStatus: selectedRowsData[0].docStatus
      });
    }
    setDataSource({
      selectList: selectedRowsData
    });
  }, []);

  // Валидность формы создания отчета хранителя
  useEffect(() => {
    setHolderReportFormValid((prevState) => ({
      ...prevState,
      docId: !!popupData.docId,
      reportDate: !!tStartDate
    }));
  }, [popupData, tStartDate]);

  /** Обновление данных при переключении на вкладку */
  useEffect(() => {
    if (id !== null && tabSelect === 2) {
      getReportTypes({ plantId });
      getReportProductTypes({ plantId });
      getReportUsers({ plantId });
    }
  }, [id, tabSelect, getReportTypes, getReportProductTypes, plantId, getReportUsers]);

  useEffect(() => {
    if (error) {
      modalErrorOpen({
        message: error.message,
        techInfo: '',
        types: 'error',
        title: formatMessage('error')
      });
      getReportErrorClose();
    }
    // console.log(reportTypes);
  }, [error, getReportErrorClose, modalErrorOpen, reportTypes]);

  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('textReportSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      getReportErrorClose();
      setVisiblePopup(false);
      setTStartDate('');
      setTEndDate('');
      setTStartDateTime({ value: '' });
    }
  }, [getReportErrorClose, okRequest]);

  // фильтр для таблицы отчета хранителей
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      setFilterDataGrid((prevState) => ({
        ...prevState,
        filter: value
      }));
    }
  }, []);

  const openDeleteHoldingReportModal = useCallback(() => {
    setVisibleHolderReportDeletePopup(true);
  }, []);

  const modalOnHiding = useCallback(() => {
    setVisiblePopup(false);
    setTStartDate('');
    setTEndDate('');
    setErrVal(false);
    setTStartDateTime({ value: '' });
    setSelectedData({
      selectedProductType: null,
      selectedUser: null,
      selectedAct: null
    });
    setFilterDataGrid((prev) => (
      { ...prev,
        dateFrom: calendarYearPreset(),
        dateTo: calendarYearPreset(true)
      }));
  }, []);

  const modalHolderReportOnHiding = useCallback(() => {
    if (!reportCreated) {
      delDocumentsNextNumber({ plant: plantId });
    }
    if (reportCreated) {
      getReportList();
    }
    setVisibleHolderReportPopup(false);
  }, [delDocumentsNextNumber, getReportList, plantId, reportCreated]);

  const modalHolderReportDeleteOnHiding = useCallback(() => {
    setVisibleHolderReportDeletePopup(false);
  }, []);

  const onClickRow = useCallback((val) => {
    setPopupData(val.data);
    setVisiblePopup(true);
    if (popupData.type === 'HOLDER_REPORT') {
      getReportList();
    }
  }, [getReportList, popupData.type]);

  /** Отрисовка строчек - кнопок по отчетам */
  const renderRows = useCallback((val) => (
    <Button onClick={() => onClickRow(val)}
            elementAttr={{ class: style.rowButton }}
            type="default"
            stylingMode="text"
            text={val.value}
    />
  ), [onClickRow]);

  const onSelectEnd = useCallback((startDate, endDate) => {
    setTStartDate(startDate);
    setTEndDate(endDate);
    setErrVal(false);
  }, []);

  const DataSelect = useCallback((props) => (
    <DateRangePicker onSelectEnd={onSelectEnd}
                     tFormat={props.tFormat || 'yyyy-MM-dd'}
                     tStartDate={tStartDate}
                     tEndDate={tEndDate}
                     tText=""
                     isSingleMode={props.isSingleMode}
    />
  ), [tStartDate, tEndDate, onSelectEnd]);

  const DataTimeSelect = useCallback(() => (
    <DateBox // type="datetime"
      displayFormat="dd.MM.yyyy" // HH:mm"
      dateSerializationFormat="yyyy-MM-dd" // HH:mm"
      width="40%"
      useMaskBehavior
      stylingMode="outlined"
      openOnFieldClick
      value={tStartDateTime.datetime}
      onValueChanged={({ value }) => {
        setTStartDateTime((item) => ({
          ...item,
          datetime: value
        }));
        setErrVal(false);
      }}
      isValid={!errVal}
    >
      <Validator>
        <RequiredRule message="Обязательно для ввода" />
      </Validator>
    </DateBox>
  ), [errVal, tStartDateTime.datetime]);

  const onReportCreate = useCallback((val) => {
    if (val.printFormat === 'EXCEL') {
      setIsExcel(true);
    } else {
      setIsExcel(false);
    }
    if (popupData.type === 'HOLDER_REPORT') {
      getReportCreate({
        url: val.url,
        dateFrom: null,
        dateTo: tStartDate,
        reportType: val.type,
        printFormat: val.printFormat,
        docId: val.docId,
        showExist: !(popupData.type === 'DOC_SIGN_REGISTRY' || popupData.type === 'DOC_SIGN_PRINTED_REGISTRY' ? val.selectTypeAct : val.selectCalculationPay),
        plantId,
        productGroup: selectedData.selectedProductType,
        user: selectedData.selectedUser,
        act: selectedData.selectedAct
      });
    }
    if (popupData.type !== 'INVENTORY' && popupData.type !== 'INV_3' && popupData.type !== 'OVER_STORAGE_REPORT') {
      if (popupData.type === 'HOLDER_REPORT') {
        if (tStartDate === '') {
          setErrVal(true);
        }
      } else if (tEndDate === '' || tStartDate === '' || compare(tEndDate, tStartDate) === -1) {
        setErrVal(true);
      } else if (popupData.type === 'PIECES_ON_HOLD_REPORT') {
        getReportCreate({
          url: val.url,
          dateFrom: tStartDate,
          dateTo: tEndDate,
          reportType: val.type,
          printFormat: 'EXCEL',
          plantIds: [plantId]
        });
      } else {
        getReportCreate({
          url: val.url,
          dateFrom: tStartDate,
          dateTo: tEndDate,
          reportType: val.type,
          printFormat: val.printFormat,
          statusFilter: popupData.type === 'DOC_SIGN_REGISTRY' || popupData.type === 'DOC_SIGN_PRINTED_REGISTRY' ? val.selectTypeAct : val.selectCalculationPay,
          plantId,
          productGroup: selectedData.selectedProductType,
          user: selectedData.selectedUser,
          act: selectedData.selectedAct
        });
      }
    } else if (tStartDateTime === '') {
      setErrVal(true);
    } else {
      getReportCreate({
        url: val.url,
        date: tStartDateTime.datetime,
        reportType: val.type,
        printFormat: val.printFormat,
        plantId
      });
    }
  }, [
    getReportCreate,
    plantId,
    tEndDate,
    tStartDateTime,
    tStartDate,
    popupData,
    selectedData
  ]);

  const onClickAddNewHolderReport = () => {
    setVisibleHolderReportPopup(true);
    setReportCreated(false);
  };

  const onClickExcel = useCallback(() => {
    if (popupData.type === 'INV_3' && !tStartDateTime.datetime) {
      setErrVal(true);
    } else {
      setReportCreated(true);
      onReportCreate({
        ...popupData,
        printFormat: 'EXCEL'
      });
    }
  }, [onReportCreate, popupData, tStartDateTime.datetime]);

  const onClickCreate = useCallback(() => {
    if (popupData.type === 'INV_3' && !tStartDateTime.datetime) {
      setErrVal(true);
    } else if (popupData.type === 'DOC_SIGN_PRINTED_REGISTRY') {
      onReportCreate({ ...popupData, printFormat: 'ZIP' });
    } else {
      setReportCreated(true);
      onReportCreate({
        ...popupData,
        printFormat: 'PDF'
      });
    }
  }, [onReportCreate, popupData, tStartDateTime.datetime]);

  const renderHolderReportPopup = useMemo(() => (
    <PopupMVP
      visible={visibleHolderReportPopup}
      onHiding={modalHolderReportOnHiding}
      title={formatMessage('textModal').textHolderReport}
      className={style.modalDop}
    >
      <div className={style.addHolderReportContainer}>
        <div className={style.addHolderReport}>
          {
            (popupData.type !== 'INVENTORY'
              && popupData.type !== 'INV_3'
              && popupData.type !== 'OVER_STORAGE_REPORT'
              && popupData.type !== 'DOC_SIGN_REGISTRY')
            && (
              <div className={errVal ? `optionsData  ${style.errorDate}` : 'optionsData'}>
                <span>{formatMessage('textSelectDate')}</span>
                <DataSelect isSingleMode />
              </div>
            )
          }
          <div>
            <span className={`${popupData.docId && Boolean(popupData.docId.trim()) ? '' : style.errorText}`}>{formatMessage('textReportNumber')}</span>
            <TextBox
              onValueChanged={({ value }) => {
                setPopupData((item) => ({
                  ...item,
                  docId: value
                }));
              }}
              value={popupData.docId}
              isValid={Boolean(popupData.docId)}
            >
              <Validator>
                <RequiredRule message="Обязательно для ввода" />
              </Validator>
            </TextBox>
          </div>
        </div>
        <div className="optionsData">
          <span>{formatMessage('textReportCalculationPay').name}</span>
          <SelectBox stylingMode="outlined"
                     items={calculationPay}
                     displayExpr="name"
                     value={
                       popupData.selectCalculationPay >= 0
                       && calculationPay[popupData.selectCalculationPay]
                     }
                     onValueChanged={({ value }) => {
                       setPopupData((item) => ({
                         ...item,
                         selectCalculationPay: value.id
                       }));
                     }}
          />
        </div>
        <div className="formButton">
          <Button type="success"
                  stylingMode="contained"
                  width={150}
                  disabled={Object.values(isHolderReportFormValid).some((val) => !val)}
                  onClick={() => {
                    setReportCreated(true);
                    onReportCreate({
                      ...popupData,
                      printFormat: 'EXCEL'
                    });
                  }}
          >
            <LoadIndicator className="indicator" visible={loading && isExcel} />
            <span>EXCEL</span>
          </Button>
          <Button text={formatMessage('textButton').cancel}
                  type="default"
                  stylingMode="text"
                  onClick={modalHolderReportOnHiding}
          />
          <Button type="default"
                  stylingMode="contained"
                  width={200}
                  disabled={Object.values(isHolderReportFormValid).some((val) => !val)}
                  onClick={() => {
                    setReportCreated(true);
                    onReportCreate({
                      ...popupData,
                      printFormat: 'PDF'
                    });
                  }}
          >
            <LoadIndicator className="indicator" visible={loading && !isExcel} />
            <span>{formatMessage('textButton').create}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    calculationPay,
    errVal,
    modalHolderReportOnHiding,
    visibleHolderReportPopup,
    isExcel,
    loading,
    onReportCreate,
    popupData,
    isHolderReportFormValid
  ]);

  const renderModalReportDelete = useMemo(() => (
    <PopupMVP
      visible={visibleHolderReportDeletePopup}
      onHiding={modalHolderReportDeleteOnHiding}
      title={formatMessage('textModal').deleteReport}
    >
      <div className="formData">
        {`${formatMessage('textModal').textDeleteHolderReport} № ${reportData.docId} ?`}
        <div className="formButton">
          <Button
            text={formatMessage('textButton').no}
            type="default"
            stylingMode="text"
            onClick={modalHolderReportDeleteOnHiding}
          />
          <Button
            type="default"
            stylingMode="contained"
            width={80}
            onClick={handleDeleteReport}
          >
            <LoadIndicator
              className="indicator"
              visible={reportDelete.loading}
            />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      </div>
    </PopupMVP>
  ), [
    visibleHolderReportDeletePopup,
    modalHolderReportDeleteOnHiding,
    reportData.docId,
    handleDeleteReport,
    reportDelete.loading]);

  const toolbarButtonAddHolderReport = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').addHolderReport}
      type={'default'}
      stylingMode={'contained'}
      onClick={onClickAddNewHolderReport}
    />
  ), []);

  const toolbarButtonDeleteAct = useMemo(() => () => (
    <Button
      text={formatMessage('textButton').remove}
      type={'danger'}
      stylingMode={'contained'}
      onClick={openDeleteHoldingReportModal}
      disabled={
        !dataSource.selectList.length
        || reportData.docStatus === 4
      }
    />
  ), [dataSource.selectList.length, openDeleteHoldingReportModal, reportData.docStatus]);

  const renderHolderReportDataGrid = useMemo(() => (
    <DataGridMVP showBorders
                 keyExpr="docNumId"
                 className="shipment"
                 dataSource={holderReportsByStock}
                 setStateStoringName={'dataGridHolderReportsData'}
                 onSelectionChanged={onSelectionChanged}
                 filterDataGrid={filterDataGrid}
                 setFilterDataGrid={setFilterDataGrid}
                 dataGridOnOptionChanged={dataGridOnOptionChanged}
                 selectionMode="single"
                 visibleInfoIcon={false}
                 visibleSummary={false}
                 visibleGroupPanel={false}
                 visibleButtonAddHolderReport
                 visibleButtonPersonVisit
                 visibleButtonUpdate
                 onClickUpdate={getReportList}
                 tText={formatMessage('textPeriod')}
                 scrolling={{
                   showScrollbar: 'always',
                   // columnRenderingMode: 'virtual',
                   mode: 'virtual',
                   useNative: false
                 }}
    >
      {columnDataGridReports.map((item) => (
        <Column dataField={item.dataField}
                  caption={item.caption}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering={false}
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
                  width={item.width ? item.width : undefined}
          />
      ))}
      <Template name="toolbarButtonAddHolderReport" render={toolbarButtonAddHolderReport} />
      <Template name="toolbarButtonVisitResponsiblePerson" render={toolbarButtonDeleteAct} />
    </DataGridMVP>
  ), [
    dataGridOnOptionChanged,
    filterDataGrid,
    getReportList,
    holderReportsByStock,
    onSelectionChanged,
    toolbarButtonAddHolderReport,
    toolbarButtonDeleteAct
  ]);

  return (
    <div className={style.containing}>
      <div className={style.main}>
        <DataGrid showBorders
                  dataSource={(
                  // TODO  переделать на getReportTypes
                  // eslint-disable-next-line no-nested-ternary
                  typeStock < 1 // typeStock === 0
                  // eslint-disable-next-line max-len
                    ? (isOffBalanceSheet)
                      ? (data.filter((item) => (item.id === 4 || item.id === 13))) // 4, 13
                      // eslint-disable-next-line max-len
                      : (data.filter((item) => (item.id >= 3 && item.id !== 5 && item.id < 8) || item.id >= 10 || item.id === 13)) // 3, 4, 6, 7, 10, 11, 12, 13
                    // eslint-disable-next-line no-nested-ternary
                    : (typeStock === 1
                    // eslint-disable-next-line max-len
                      ? (data.filter((item) => item.id < 3 || item.id === 4 || item.id === 6 || item.id === 7 || item.id >= 11 || item.id === 13)) // 0, 1, 2, 4 ,6, 7, 11, 12, 13
                      : (plantId === '7838') // Бьеф
                        // eslint-disable-next-line max-len
                        ? data.filter((item) => item.id === 2 || item.id === 4 || item.id === 5 || item.id === 6 || item.id === 9 || item.id === 12 || item.id === 13) // 2, 4, 5, 6, 9, 12, 13
                      // eslint-disable-next-line max-len
                        : (plantId === '8164') // ИМЗ ПФ
                        // eslint-disable-next-line max-len
                          ? data.filter((item) => item.id === 2 || item.id === 4 || item.id === 6 || item.id === 12 || item.id === 13) // 2, 4, 6, 12, 13
                          // eslint-disable-next-line max-len
                          : data.filter((item) => item.id === 2 || item.id === 4 || item.id === 6 || item.id === 9 || item.id === 12 || item.id === 13)) // 2, 4, 6, 9, 12, 13
                  )}
        >
          <Sorting mode="none" />
          <Column dataField="name"
                  caption={formatMessage('textReportName')}
                  cellRender={renderRows}
          />
        </DataGrid>
      </div>
      <div>
        {popupData.type === 'HOLDER_REPORT' ? (
          <PopupMVP visible={visiblePopup}
                    onHiding={modalOnHiding}
                    title={popupData.name}
                    // className={style.modalDop}
                    resizeEnabled={false}
                    dragEnabled={false}
                    fullScreen
          >
            <div className="formData">
              {renderHolderReportPopup}
              {renderModalReportDelete}
              <div className={style.containing}>
                {renderHolderReportDataGrid}
              </div>
            </div>
          </PopupMVP>
        ) : (
          <PopupMVP visible={visiblePopup}
                    onHiding={modalOnHiding}
                    title={popupData.name}
                    className={style.modalDop}
                    height="auto"
          >
            <div className="formData">
              {
                (popupData.type === 'INVENTORY'
                  || popupData.type === 'INV_3'
                  || popupData.type === 'OVER_STORAGE_REPORT'
                  || popupData.type === 'FINISHED_PRODUCT_REPORT')
                && (
                  <div className={errVal ? `optionsData  ${style.errorDate}` : 'optionsData'}>
                    <span>{formatMessage('textSelectDateTime')}</span>
                    <DataTimeSelect />
                  </div>
                )
              }
              {
                (popupData.type === 'DOC_SIGN_REGISTRY' || popupData.type === 'DOC_SIGN_PRINTED_REGISTRY')
                && (
                  <div className={'optionsRow'}>
                    <div className={errVal ? `optionData  ${style.errorDate}` : 'optionData'}>
                      <span>{formatMessage('textSelectPeriod')}</span>
                      <DataSelect />
                    </div>
                    <div className={'optionData'}>
                      {
                        popupData.type !== 'DOC_SIGN_PRINTED_REGISTRY'
                          && (
                          <>
                            <span>{formatMessage('textTypeProduct')}</span>
                            <SelectBox items={reportProductTypes.data}
                                       displayExpr="value"
                                       valueExpr="key"
                                       value={selectedData.selectedProductType}
                                       onValueChanged={({ value }) => {
                                         setSelectedData((item) => ({
                                           ...item,
                                           selectedProductType: value
                                         }));
                                       }}
                                       stylingMode="outlined"
                                       style={{ marginBottom: '12px' }}
                            />
                          </>
                          )
                      }
                      <span>{formatMessage('textSelectAct')}</span>
                      <SelectBox items={acts}
                                 displayExpr="key"
                                 valueExpr="value"
                                 value={selectedData.selectedAct}
                                 onValueChanged={({ value }) => {
                                   setSelectedData((item) => ({
                                     ...item,
                                     selectedAct: value
                                   }));
                                 }}
                                 stylingMode="outlined"
                      />
                    </div>
                  </div>
                )
              }
              {
                (popupData.type !== 'INVENTORY'
                  && popupData.type !== 'INV_3'
                  && popupData.type !== 'OVER_STORAGE_REPORT'
                  && popupData.type !== 'DOC_SIGN_REGISTRY'
                  && popupData.type !== 'DOC_SIGN_PRINTED_REGISTRY')
                && (
                  <div className={errVal ? `optionsData  ${style.errorDate}` : 'optionsData'}>
                    <span>{formatMessage('textSelectPeriod')}</span>
                    <DataSelect />
                  </div>
                )
              }
              {
                (popupData.type === 'DOC_SIGN_REGISTRY' || popupData.type === 'DOC_SIGN_PRINTED_REGISTRY')
                && (
                  <>
                    <div className="optionsData">
                      <span>{formatMessage('textReportTypeAct').name}</span>
                      <SelectBox stylingMode="outlined"
                                 items={typeAct}
                                 displayExpr="name"
                                 value={
                                   popupData.selectTypeAct >= 0
                                   && typeAct[popupData.selectTypeAct]
                                 }
                                 onValueChanged={({ value }) => {
                                   setPopupData((item) => ({
                                     ...item,
                                     selectTypeAct: value.id
                                   }));
                                 }}
                      />
                    </div>
                    {
                      popupData.type !== 'DOC_SIGN_PRINTED_REGISTRY'
                      && (
                        <div className="optionsData">
                          <span>{formatMessage('textSelectUser')}</span>
                          <SelectBox stylingMode="outlined"
                                     items={reportUsers.data}
                                     displayExpr="value"
                                     valueExpr="key"
                                     searchEnabled
                                     acceptCustomValue
                                     value={selectedData.selectedUser}
                                     onValueChanged={({ value }) => {
                                       setSelectedData((item) => ({
                                         ...item,
                                         selectedUser: value
                                       }));
                                     }}
                          />
                        </div>
                      )
                    }
                  </>
                )
              }
              {
                popupData.type === 'PROCESSING_REPORT'
                && (
                  <div className="optionsData">
                    <span>{formatMessage('textReportDross')}</span>
                    <NumberBox value={dross}
                               stylingMode="filled"
                               placeholder={formatMessage('textReportDross')}
                               width={300}
                               onValueChanged={({ value }) => setDross(value)}
                               showClearButton
                    />
                  </div>
                )
              }
              <div className="formButton">
                {
                  popupData.type !== 'DOC_SIGN_PRINTED_REGISTRY'
                  && (
                    <Button type="success"
                            stylingMode="contained"
                            width={150}
                            onClick={onClickExcel}
                    >
                      <LoadIndicator className="indicator" visible={loading && isExcel} />
                      <span>EXCEL</span>
                    </Button>
                  )
                }
                <Button text={formatMessage('textButton').cancel}
                        type="default"
                        stylingMode="text"
                        onClick={modalOnHiding}
                />
                {(popupData.type !== 'TTN_REPORT'
                  && popupData.type !== 'PIECES_ON_HOLD_REPORT') && (
                  <Button type="default"
                          stylingMode="contained"
                          width={200}
                          onClick={onClickCreate}
                >
                    <LoadIndicator className="indicator" visible={loading && !isExcel} />
                    <span>{formatMessage('textButton').create}</span>
                  </Button>
                )}
              </div>
            </div>
          </PopupMVP>
        )}
      </div>
    </div>
  );
};
export default Reports;
